import React, { useEffect } from 'react';
import { compose } from 'redux';
import { FormLabel, ModalProps } from '@material-ui/core';
import { Field, reduxForm, getFormValues } from 'redux-form/immutable';
import { useSelector, useDispatch } from 'react-redux';

import { CompanySelectInput } from 'components/CompanySelectInput/CompanySelectInput';
import {
  Modal,
  ModalContents,
  ModalTitle,
  ModalTypography,
  ModalButton,
} from 'components/Modal/Modal';

import { DeedHeartHands } from './DeedHeartHands';
import { selectError, selectLoading } from './selectors';
import {
  clearErrorAction,
  createPartnerAction,
  REQUEST_CORPORATE_PARTNERSHIP_FORM_IDENTIFIER,
} from './types';

const FormCompanySelectInput = ({ input }) => {
  const { onChange, value } = input;

  return <CompanySelectInput values={value || []} onChange={onChange} />;
};

const RequestCorporatePartnershipModal = ({
  onClickClose,
  style,
  ...props
}: {
  onClickClose: () => void;
} & ModalProps): JSX.Element => {
  const dispatch = useDispatch();
  const formValues = useSelector(getFormValues(REQUEST_CORPORATE_PARTNERSHIP_FORM_IDENTIFIER));
  const error = useSelector(selectError);
  const loading = useSelector(selectLoading);

  useEffect(() => {
    dispatch(clearErrorAction());
  }, [dispatch]);

  const selectedCompanies = formValues?.get('companies');

  return (
    <Modal
      disableAutoFocus
      style={{
        alignItems: 'center',
        justifyContent: 'center',
        ...style,
      }}
      {...props}
    >
      <ModalContents
        onClickClose={onClickClose}
        header={<DeedHeartHands />}
        headerStyles={{
          paddingTop: 16,
        }}
        body={
          <>
            <ModalTitle>Are you affiliated with a company?</ModalTitle>
            <ModalTypography>
              If you have an existing relationship with a company that uses Deed for their social
              impact work, search for them below. (Select all that apply.)
            </ModalTypography>
            <form>
              <Field name="companies" component={FormCompanySelectInput} />
            </form>
            {error && (
              <FormLabel error style={{ display: 'block', marginTop: 16 }}>
                An error occurred while trying to request affiliation. Please try again.
              </FormLabel>
            )}
          </>
        }
        actions={
          <>
            <ModalButton
              disabled={selectedCompanies?.length < 1}
              onClick={(): void => {
                selectedCompanies?.forEach((companyId: string) =>
                  dispatch(createPartnerAction(companyId))
                );
                onClickClose();
              }}
            >
              {loading ? 'Requesting Affiliation…' : 'Request Affiliation'}
            </ModalButton>
          </>
        }
      />
    </Modal>
  );
};

const withForm = reduxForm({
  form: REQUEST_CORPORATE_PARTNERSHIP_FORM_IDENTIFIER,
  enableReinitialize: true,
});

export default compose(withForm)(RequestCorporatePartnershipModal);
